module.exports = __webpack_public_path__ + "img/healthscreening1.5238e2e5.jpg";